<template>
  <div v-if="carregaModel">
    <v-row class="d-flex justify-center">
      <v-card-title class="text-h5 primary--text">
        Resultado da Consulta
      </v-card-title>
    </v-row>
    <v-row class="justify-end">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-3 mb-3"
            v-bind="attrs"
            v-on="on"
            depressed
            color="primary"
            @click="exportaBureau"
            data-cy="exportarPDF"
          >
            <v-icon>ph-file-pdf</v-icon>
          </v-btn>
        </template>
        <span>Exportar PDF</span>
      </v-tooltip>
    </v-row>
    <v-card-text>
      <span class="text-h5 ml-3 primary--text"> Dados da Consulta </span>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">{{
            model.IsPJ ? "Razão Social" : 'Nome'
          }}</v-row>
          <v-row class="text-subtitle">{{ model.Nome }}</v-row>
        </v-col>
        <v-col cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">Documento Federal</v-row>
          <v-row class="text-subtitle">
            {{ model.NumeroDocumento }}
          </v-row>
        </v-col>
        <v-col cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">{{
            model.IsPJ ? "Data de Fundação" : "Data de Nascimento"
          }}</v-row>
          <v-row class="text-subtitle">{{ model.DataNascimento }}</v-row>
        </v-col>
        <v-col v-if="!model.IsPJ" cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">Sexo</v-row>
          <v-row class="text-subtitle">{{ model.Sexo }}</v-row>
        </v-col>
        <v-col cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">E-mail</v-row>
          <v-row class="text-subtitle">{{ model.Email }}</v-row>
        </v-col>
        <v-col v-if="!model.IsPJ" cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">Estado Civil</v-row>
          <v-row class="text-subtitle">{{ model.EstadoCivil }}</v-row>
        </v-col>
        <v-col cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">Idade</v-row>
          <v-row class="text-subtitle">{{ model.Idade }}</v-row>
        </v-col>
        <v-col v-if="!model.IsPJ" cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">RG</v-row>
          <v-row class="text-subtitle">{{ model.RG }}</v-row>
        </v-col>
        <v-col v-if="!model.IsPJ" cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">Nome da Mãe</v-row>
          <v-row class="text-subtitle">{{ model.Filiacao }}</v-row>
        </v-col>
        <v-col v-if="!model.IsPJ" cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">Nacionalidade</v-row>
          <v-row class="text-subtitle">{{ model.Nacionalidade }}</v-row>
        </v-col>
        <v-col v-if="!model.IsPJ" cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">Carteira Profissional</v-row>
          <v-row class="text-subtitle">{{ model.CarteiraProf }}</v-row>
        </v-col>
        <v-col v-if="!model.IsPJ" cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">PIS</v-row>
          <v-row class="text-subtitle">{{ model.PIS }}</v-row>
        </v-col>
        <v-col v-if="!model.IsPJ" cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">Signo</v-row>
          <v-row class="text-subtitle">{{ model.Signo }}</v-row>
        </v-col>
        <v-col v-if="!model.IsPJ" cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">Grau de Instrução</v-row>
          <v-row class="text-subtitle">{{ model.GrauInstrucao }}</v-row>
        </v-col>
      </v-row>
      <template v-if="model.Empresa.length >= 1">
        <span class="text-h5 ml-3 primary--text"> Dados da Empresa </span>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Atividade Comercial</v-row>
            <v-row class="text-subtitle">
              {{ model.Empresa[0].AtividadeComercial }}
            </v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Natureza Jurídica</v-row>
            <v-row class="text-subtitle">
              {{ model.Empresa[0].NaturezaJuridica }}
            </v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Porte</v-row>
            <v-row class="text-subtitle">{{ model.Empresa[0].Porte }}</v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">CNAE</v-row>
            <v-row class="text-subtitle">{{ model.Empresa[0].CNAE }}</v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">CNAE2</v-row>
            <v-row class="text-subtitle">{{ model.Empresa[0].CNAE2 }}</v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Tipo</v-row>
            <v-row class="text-subtitle">{{ model.Empresa[0].Tipo }}</v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Situação Especial</v-row>
            <v-row class="text-subtitle">
              {{ model.Empresa[0].SituacaoEspecial }}
            </v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Data da Situação Especial</v-row>
            <v-row class="text-subtitle">
              {{ model.Empresa[0].DtSituacaoEspecial }}
            </v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Situação Cadastral</v-row>
            <v-row class="text-subtitle">
              {{ model.Empresa[0].SituacaoCadastral }}
            </v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Data da Situação Cadastral</v-row>
            <v-row class="text-subtitle">
              {{ model.Empresa[0].DtSituacaoCadastral }}
            </v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Data de Abertura</v-row>
            <v-row class="text-subtitle">
              {{ model.Empresa[0].DtAbertura }}
            </v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">CEP</v-row>
            <v-row class="text-subtitle">{{ model.Empresa[0].CEP }}</v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">UF</v-row>
            <v-row class="text-subtitle">{{ model.Empresa[0].UF }}</v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Cidade</v-row>
            <v-row class="text-subtitle">{{ model.Empresa[0].Cidade }}</v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Logradouro</v-row>
            <v-row class="text-subtitle">
              {{ model.Empresa[0].Logradouro }}
            </v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Número</v-row>
            <v-row class="text-subtitle">
              {{ model.Empresa[0].NroLogradouro }}
            </v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Complemento</v-row>
            <v-row class="text-subtitle">
              {{ model.Empresa[0].Complemento }}
            </v-row>
          </v-col>
        </v-row>
      </template>
      <template v-if="model.CCF.length >= 1">
        <span class="text-h5 ml-3 primary--text"> CCF </span>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Documento Federal</v-row>
            <v-row class="text-subtitle">
              {{ model.CCF[0].Documento }}
            </v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Nome</v-row>
            <v-row class="text-subtitle">
              {{ model.CCF[0].Nome }}
            </v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Telefone</v-row>
            <v-row class="text-subtitle">{{ model.CCF[0].TelefoneFormatted }}</v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">CEP</v-row>
            <v-row class="text-subtitle">{{ model.CCF[0].CEP }}</v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">UF</v-row>
            <v-row class="text-subtitle">{{ model.CCF[0].UF }}</v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Cidade</v-row>
            <v-row class="text-subtitle">{{ model.CCF[0].Cidade }}</v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Quantidade de Ocorrências</v-row>
            <v-row class="text-subtitle">{{ model.CCF[0].QtdeOcorrencias }}</v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Data da Última Ocorrência</v-row>
            <v-row class="text-subtitle">{{ model.CCF[0].DtUltimaOcorrencia }}</v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Banco</v-row>
            <v-row class="text-subtitle">{{ model.CCF[0].NomeBanco }}</v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Agência</v-row>
            <v-row class="text-subtitle">
              {{ model.CCF[0].NomeAgencia }}
            </v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Endereço da Agencia</v-row>
            <v-row class="text-subtitle">
              {{ model.CCF[0].EnderecoAgencia }}
            </v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Motivo da Devolução</v-row>
            <v-row class="text-subtitle">
              {{ model.CCF[0].MotivoDevolucao }}
            </v-row>
          </v-col>
        </v-row>
      </template>
      <template v-if="model.Telefone && model.Telefone.length >= 1">
        <span class="text-h5 ml-3 primary--text">Telefones</span>
        <v-divider></v-divider>
        <v-expansion-panels focusable class="mb-3 mt-3">
          <v-expansion-panel>
            <v-expansion-panel-header class="primary--text">
              Telefones
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
                <v-col
                  cols="3"
                  v-for="(telefone, i) in model.Telefone"
                  :key="`${telefone}_${i}`"
                >
                  {{ telefone }}
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
      <template v-if="model.Endereco && model.Endereco.length >= 1">
        <span class="text-h5 ml-3 primary--text">Enderecos</span>
        <v-divider></v-divider>
        <v-expansion-panels focusable class="mb-3 mt-3">
          <v-expansion-panel>
            <v-expansion-panel-header class="primary--text">
              Endereços
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row
                v-for="(endereco, i) in model.Endereco"
                :key="`${endereco.CEP}_${i}`"
              >
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle"> Nome do Titular </v-row>
                  <v-row class="text-subtitle">
                    {{ endereco.NomeTitular }}
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle"> CEP </v-row>
                  <v-row class="text-subtitle"> {{ endereco.CEP }} </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle"> UF </v-row>
                  <v-row class="text-subtitle"> {{ endereco.UF }} </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle"> Cidade </v-row>
                  <v-row class="text-subtitle"> {{ endereco.Cidade }} </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle"> Bairro </v-row>
                  <v-row class="text-subtitle"> {{ endereco.Bairro }} </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle"> Logradouro </v-row>
                  <v-row class="text-subtitle">
                    {{ endereco.Logradouro }}
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle"> Número </v-row>
                  <v-row class="text-subtitle">
                    {{ endereco.NroLogradouro }}
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle"> Complemento </v-row>
                  <v-row class="text-subtitle">
                    {{ endereco.Complemento }}
                  </v-row>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
      <template
        v-if="model.HistoricoTrabalho && model.HistoricoTrabalho.length >= 1"
      >
        <span class="text-h5 ml-3 primary--text"> Histórico Profissional </span>
        <v-divider></v-divider>
        <v-expansion-panels focusable class="mb-3 mt-3">
          <v-expansion-panel>
            <v-expansion-panel-header class="primary--text">
              Histórico Profissional
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row
                v-for="(historico, i) in model.HistoricoTrabalho"
                :key="`${historico.CNPJ}_${i}`"
              >
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="3" class="mt-3 mb-5">
                  <v-row class="text-subtitle"> CNPJ </v-row>
                  <v-row class="text-subtitle">
                    {{ historico.CNPJ }}
                  </v-row>
                </v-col>
                <v-col cols="8" class="mt-3">
                  <v-row class="text-subtitle">Razao Social</v-row>
                  <v-row class="text-subtitle">
                    {{ historico.RazaoSocial }}
                  </v-row>
                </v-col>
                <v-col cols="3" class="mt-3">
                  <v-row class="text-subtitle">Data de Admissão</v-row>
                  <v-row class="text-subtitle">
                    {{ historico.DtAdmissao }}
                  </v-row>
                </v-col>
                <v-col cols="3" class="mt-3 mb-5">
                  <v-row class="text-subtitle">Data de Demissão</v-row>
                  <v-row class="text-subtitle">
                    {{ historico.DtDemissao }}
                  </v-row>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
      <template v-if="model.Veiculo && model.Veiculo.length >= 1">
        <span class="text-h5 ml-3 primary--text"> Veículos </span>
        <v-divider></v-divider>
        <v-expansion-panels focusable class="mb-3 mt-3">
          <v-expansion-panel>
            <v-expansion-panel-header class="primary--text">
              Veículos
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row
                v-for="(veiculo, i) in model.Veiculo"
                :key="`${veiculo.Placa}_${i}`"
              >
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle"> Placa </v-row>
                  <v-row class="text-subtitle">
                    {{ veiculo.Placa }}
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle">Nome</v-row>
                  <v-row class="text-subtitle">
                    {{ veiculo.Nome }}
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle">Documento</v-row>
                  <v-row class="text-subtitle">
                    {{ veiculo.Documento }}
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle">Marca/Modelo</v-row>
                  <v-row class="text-subtitle">
                    {{ veiculo.MarcaModelo }}
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle">Ano de Fabricação</v-row>
                  <v-row class="text-subtitle">
                    {{ veiculo.AnoFabricacao }}
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle">Chassis</v-row>
                  <v-row class="text-subtitle">
                    {{ veiculo.Chassis }}
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle">Renavam</v-row>
                  <v-row class="text-subtitle">
                    {{ veiculo.Renavam }}
                  </v-row>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
      <template v-if="model.Sociedade && model.Sociedade.length >= 1">
        <span class="text-h5 ml-3 primary--text"> Sociedade </span>
        <v-divider></v-divider>
        <v-expansion-panels focusable class="mb-3 mt-3">
          <v-expansion-panel>
            <v-expansion-panel-header class="primary--text">
              Sócios
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row v-for="(socio, i) in model.Sociedade" :key="`socio_${i}`">
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle"> CPF </v-row>
                  <v-row class="text-subtitle">
                    {{ socio.CPF }}
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle"> RG </v-row>
                  <v-row class="text-subtitle">
                    {{ socio.RG }}
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle"> Nome </v-row>
                  <v-row class="text-subtitle">
                    {{ socio.Socio }}
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle"> CNPJ </v-row>
                  <v-row class="text-subtitle">
                    {{ socio.CNPJ }}
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle"> Nome da Empresa </v-row>
                  <v-row class="text-subtitle">
                    {{ socio.NomeEmpresa }}
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle"> Inscrição Estadual </v-row>
                  <v-row class="text-subtitle">
                    {{ socio.InscricaoEstadual }}
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle"> Data de Ingresso </v-row>
                  <v-row class="text-subtitle">
                    {{ socio.DtIngresso }}
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle"> Data de Início </v-row>
                  <v-row class="text-subtitle">
                    {{ socio.DtInicio }}
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row class="text-subtitle"> Participação </v-row>
                  <v-row class="text-subtitle">
                    {{ socio.Participacao }}
                  </v-row>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
    </v-card-text>
  </div>
</template>
<script>
export default {
  data () {
    return {
      model: {},
      carregaModel: false,
    };
  },
  methods: {
    ConsultaAllCheck (documento) {
      const th = this;

      const dto = {
        consulta: {
          DocumentoCliente: documento,
        },
      };
      th.$set(th, 'model', {})
      th.$api.Multiplo.Post('ConsultaAllCheck', dto).then((response) => {
        if (th.$api.UI.PostLoadData(response, true)) {
          th.$set(th, 'model', JSON.parse(response.JSON));

          if (!th.model.Error) {
            th.carregaModel = true;

            const modelKeys = Object.keys(th.model);

            modelKeys.forEach((key) => {
              if (th.model[key] === '') {
                th.model[key] = '---';
              }
            });

            if (th.model.Empresa.length >= 1) {
              const empresaKeys = Object.keys(th.model.Empresa[0]);

              empresaKeys.forEach((key) => {
                if (
                  th.model.Empresa[0][key] === '' ||
                  th.model.Empresa[0][key] === null
                ) {
                  th.model.Empresa[0][key] = '---';
                } else if (key === 'CEP') {
                  if (th.model.Empresa[0].CEP.length === 7) {
                    th.model.Empresa[0].CEP = '0' + th.model.Empresa[0].CEP;
                  }
                  th.model.Empresa[0].CEP = th.$api.UI.Format.Cep(
                    th.model.Empresa[0].CEP
                  );
                } else if (
                  key === 'DtAbertura' ||
                  key === 'DtSituacaoCadastral' ||
                  key === 'DtSituacaoEspecial'
                ) {
                  th.model.Empresa[0][key] = th.$api.UI.Format.Date(
                    th.model.Empresa[0][key]
                  );
                }
              });
            }

            if (th.model.CCF.length >= 1) {
              const CCFKeys = Object.keys(th.model.CCF[0]);

              CCFKeys.forEach((key) => {
                if (th.model.CCF[0][key] === '' || th.model.CCF[0][key] === null) {
                  th.model.CCF[0][key] = '---';
                } else if (key === 'DtUltimaOcorrencia') {
                  th.model.CCF[0][key] = th.$api.UI.Format.Date(th.model.CCF[0][key]);
                } else if (key === 'CEP') {
                  th.model.CCF[0][key] = th.$api.UI.Format.Cep(th.model.CCF[0][key]);
                }
              });
              th.model.CCF[0].TelefoneFormatted =
                th.model.CCF[0].Telefone !== '---' && th.model.CCF[0].DDD !== '---'
                  ? th.$api.UI.Format.Telefone(`${th.model.CCF[0].DDD}${th.model.CCF[0].Telefone}`)
                  : '---';

              th.model.CCF[0].Documento =
                th.model.CCF[0].Documento !== '---'
                  ? th.$api.UI.Format.DocumentoFederal(th.model.CCF[0].Documento)
                  : '---';
            };

            th.model.Sociedade.forEach((el) => {
              const socioKeys = Object.keys(el);

              socioKeys.forEach((key) => {
                if (el[key] === '' || el[key] === null) {
                  el[key] = '---';
                } else if (key === 'CPF' || key === 'CNPJ') {
                  el[key] = th.$api.UI.Format.DocumentoFederal(el[key]);
                } else if (key === 'DtIngresso' || key === 'DtInicio') {
                  el[key] = th.$api.UI.Format.Date(el[key]);
                }
              });
            });

            if (th.model.Sexo === 'F') th.$set(th.model, 'Sexo', 'Feminino');
            else if (th.model.Sexo === 'M') {
              th.$set(th.model, 'Sexo', 'Masculino');
            }

            const telefones = [];
            const enderecos = [];
            th.model.Telefone.forEach((endereco) => {
              if (
                endereco.DDD &&
                endereco.DDD !== '' &&
                endereco.Telefone &&
                endereco.Telefone !== ''
              ) {
                telefones.push(
                  th.$api.UI.Format.Celular(endereco.DDD + endereco.Telefone)
                );
              }
              if (endereco.CEP && endereco.CEP !== '') {
                enderecos.push({
                  Bairro: endereco.Bairro !== '' ? endereco.Bairro : '---',
                  CEP: th.$api.UI.Format.Cep(endereco.CEP),
                  Cidade: endereco.Cidade !== '' ? endereco.Cidade : '---',
                  Complemento:
                    endereco.Complemento !== '' ? endereco.Complemento : '---',
                  DocumentoTitular:
                    endereco.Documento !== ''
                      ? th.$api.UI.Format.DocumentoFederal(endereco.Documento)
                      : '---',
                  DtInstalacao:
                    endereco.DtInstalacao !== ''
                      ? endereco.DtInstalacao
                      : '---',
                  Logradouro:
                    endereco.Logradouro !== '' ? endereco.Logradouro : '---',
                  NomeTitular: endereco.Nome !== '' ? endereco.Nome : '---',
                  NroLogradouro:
                    endereco.NroLogradouro !== ''
                      ? endereco.NroLogradouro
                      : '---',
                  UF: endereco.UF !== '' ? endereco.UF : '---',
                });
              }
            });

            th.model.HistoricoTrabalho.forEach(
              ({ CNPJ, DtAdmissao, DtDemissao }, i) => {
                th.model.HistoricoTrabalho[i].CNPJ =
                  th.$api.UI.Format.DocumentoFederal(CNPJ);
                th.model.HistoricoTrabalho[i].DtAdmissao =
                  th.$api.UI.Format.Date(th.$api.UI.Parse.Date(DtAdmissao));
                th.model.HistoricoTrabalho[i].DtDemissao =
                  th.$api.UI.Date.IsValid(DtDemissao)
                    ? th.$api.UI.Format.Date(DtAdmissao)
                    : DtDemissao;
              }
            );

            th.$set(th, 'model', {
              ...th.model,
              IsPJ: th.model.NumeroDocumento.length === 14,
              NumeroDocumento: th.$api.UI.Format.DocumentoFederal(
                th.model.NumeroDocumento
              ),
              Telefone: telefones,
              Endereco: enderecos,
            });
          } else {
            th.$api.UI.ShowError('Erro', th.model.ErrorDescription);
            th.carregaModel = false;
            th.$set(th, 'model', {});
          }
        }
      });
    },
    exportaBureau (tipo) {
      const th = this;
      const dto = {
        consulta: { ...th.model },
      };
      th.$api.Bureau.GerarPDFAllCheck(dto).then((response) => {
        if (th.$api.UI.PostLoadData(response, true)) {
          th.downloadBureau(response.data, tipo);
        }
      });
    },
    downloadBureau (file, tipo) {
      var nomeArquivo = 'ALL CHECK - ' + this.model.NumeroDocumento + '.pdf';
      var blob =
        tipo === 1
          ? new Blob(['\ufeff', file], { type: 'text/csv' + ';charset=utf-8' })
          : file;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeArquivo);
      document.body.appendChild(link);
      link.click();
    },
  },
};
</script>
<style scoped></style>
